import {useState} from "react";
import {
  Button,
  FormControl,
  Spinner,
} from "react-bootstrap";
import moment from "moment";
import DateTimeRangeContainer from "react-advanced-datetimerange-picker";
import { useDispatch, useSelector } from "react-redux";
import {
  getLoggerDataAction,
} from "../../../Redux/Actions/AdminActions";
import NoasCounter from "../noasCounter";
import { IReduxState } from "../../../utils/types";

const LoggerTab = () => {
    const dispatch = useDispatch();
    const adminState = useSelector((state: IReduxState) => state.Admin);
    const [state, setState] = useState({
        startDate: moment().subtract(1, "days").startOf("day"),
        endDate: moment().subtract(1, "days").endOf("day"),
      });
    const { startDate, endDate } = state;
    let local = {
        format: "DD-MM-YYYY HH:mm",
        sundayFirst: true,
      };
    const applyCallback = (startDate: any, endDate: any) => {
        setState({
          startDate: startDate,
          endDate: endDate,
        });
    };
    let value = `${startDate.format("DD-MM-YYYY HH:mm")} - ${endDate.format(
        "DD-MM-YYYY HH:mm"
      )}`;
    return (
        <><div>
                <div className="date-label">
                  <h3>Selected Date</h3>
                </div>
                <DateTimeRangeContainer
                  ranges={{}}
                  start={startDate}
                  end={endDate}
                  local={local}
                  maxDate={moment()}
                  applyCallback={applyCallback}
                  smartMode
                  noMobileMode
                >
                  <FormControl
                    id="formControlsTextB"
                    type="text"
                    // label="Text"
                    placeholder="Enter text"
                    style={{ cursor: "pointer" }}
                    value={value}
                    readOnly
                  />
                </DateTimeRangeContainer>
                <div className="calander-select">
                  <Button onClick={() => dispatch(getLoggerDataAction(state))}>
                    {adminState?.loading && (
                      <span style={{ marginRight: 10 }}>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true" />
                      </span>
                    )}
                    Export CSV
                  </Button>
                </div>
              </div>
                <NoasCounter />
              </>
        
    )
}
export default LoggerTab